import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isMobile } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.LocationSpoofing
const label = visitFilterLabelMap[key]

export const locationSpoofingColumn = () =>
  columnHelper.display({
    id: 'locationSpoofing',
    header: 'Location Spoofing',
    cell: ({ row }) => {
      if (!isMobile(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.location_spoofing

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
